import { GilAttentionItem } from '@protos/learning_management/lms.assessment.student.apis_pb';
import { useNavigate } from 'react-router-dom';
import {
  GIL_Reports_Group,
  GIL_Reports_Project,
  GIL_Reports_Student_Project,
} from '../../../routeHandling/RoutesNomenclature';

/**
 * Opens the report a "Needs Your Attention" item is about: the group's report
 * for a collaboration group, the student's report for a student working alone,
 * and the project report otherwise.
 */
export const useOpenAttentionItem = () => {
  const navigate = useNavigate();

  return (item: GilAttentionItem) => {
    if (item.studentGroupId) {
      navigate(
        `${GIL_Reports_Group}/${item.assessmentId}/${item.studentGroupId}`
      );
    } else if (item.students.length === 1) {
      navigate(
        `${GIL_Reports_Student_Project}/${item.students[0].studentId.toString()}/${
          item.assessmentId
        }`
      );
    } else {
      navigate(`${GIL_Reports_Project}/${item.assessmentId}`);
    }
  };
};
